import { Chip, ListItem, Modal, ModalBody } from '@change/ds-core-ui';
import { CheckIcon } from '@change/ds-icons/CheckIcon';
import { ExpandIcon } from '@change/ds-icons/ExpandIcon';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useMobileSortSelector } from './hooks/useMobileSortSelector';

type SortSelectorProps = {
	currentRefinement: string;
	currentLabel: string;
	sortByTitle: string;
	options: ReadonlyArray<{ label: string; value: string; subtitle: string }>;
	// FIXME(SelectMenu): Using string | number because the component requires Key type from react-aria as value
	changeSelection: (value: string | number) => void;
};

export const MobileSortSelector: React.FC<SortSelectorProps> = ({
	sortByTitle,
	currentRefinement,
	currentLabel,
	options,
	changeSelection,
}) => {
	const { translate } = useI18n();
	const {
		actions: { updateSort },
	} = useMobileSortSelector({ changeSelection });

	return (
		<div className="relative">
			<Modal
				trigger={
					<Chip as="button" trailingIcon={<ExpandIcon />} forceInteractive>
						{sortByTitle} {currentLabel}
					</Chip>
				}
				onClose={() => {}}
				closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
			>
				<ModalBody className="space-y-3 pb-10">
					{({ close }) => (
						<>
							{options.map((option) => (
								<ListItem
									onClick={() => {
										updateSort(option.value);
										close();
									}}
									key={option.value}
									label={option.label}
									trailingIcon={currentRefinement === option.value ? <CheckIcon /> : undefined}
									body={option.subtitle}
									className="focus-visible:outline-stroke-focus w-full cursor-pointer text-start focus-visible:outline focus-visible:outline-offset-2"
									data-qa={`sort-option-${option.value}`}
								/>
							))}
						</>
					)}
				</ModalBody>
			</Modal>
		</div>
	);
};
